import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { motion, useAnimation, useInView } from "framer-motion";

const StatBlock = ({ number, label, delay }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const controls = useAnimation();

  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
  }, [isInView, controls]);

  return (
    <motion.div
      ref={ref}
      variants={{
        hidden: { opacity: 0, y: 100, scale: 0.8 },
        visible: { opacity: 1, y: 0, scale: 1 },
      }}
      initial="hidden"
      animate={controls}
      transition={{ duration: 0.5, delay, type: "spring" }}
    >
      <h1>{number}</h1>
      <h3>{label}</h3>
    </motion.div>
  );
};

const Stats = () => {
  return (
    <Container>
      <StatBlock number="200+" label="Kunden" delay={0.2} />
      <hr />
      <StatBlock number="4+" label="Jahre" delay={0.4} />
      <hr />
      <StatBlock number="8+" label="Zertifizierung" delay={0.6} />
    </Container>
  );
};

const Container = styled.div`
  padding: 0em 7% 4em 7%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3em;
  /* background-color: #daccbd; */
  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1em;
    h3 {
      font-weight: 400;
      color: #777777;
      text-align: center;
    }
    h1 {
      font-family: "The Seasons";
      font-size: 5vw;
      font-weight: 100;
    }
    .icon {
      font-size: 4em;
      color: #278527c1;
    }
  }
  hr {
    height: 100px;
    border: none;
    border-right: 1px solid black;
  }
  @media (max-width: 650px) {
    gap: 1em;
  }
  @media (max-width: 530px) {
    gap: 1em;
    flex-direction: column;
    div {
      h1 {
        font-size: 20vw;
      }
    }
    hr {
      width: 100%;
      border-bottom: 1px solid black;
      height: 1px;
    }
  }
`;

export default Stats;
